import {
  Brightness4 as DarkModeIcon,
  Brightness7 as LightModeIcon,
} from '@mui/icons-material';
import {
  IconButton,
  Tooltip,
} from '@mui/material';
import React from 'react';

import { useThemeMode } from '../../contexts/ThemeContext';

function ThemeToggle({ size = 'medium' }) {
  const { isDarkMode, toggleTheme } = useThemeMode();

  return (
    <Tooltip title={isDarkMode ? '라이트 모드로 전환' : '다크 모드로 전환'}>
      <IconButton
        onClick={toggleTheme}
        color="inherit"
        size={size}
        sx={{
          // Use CSS variables for consistent transitions across theme changes
          transition: 'transform var(--theme-transitions-duration, 300ms) ease-in-out, background-color var(--theme-transitions-duration, 300ms) ease-in-out',
          backgroundColor: 'var(--theme-palette-action-hover, rgba(0, 0, 0, 0.04))',
          '&:hover': {
            transform: 'scale(1.1)',
            backgroundColor: 'var(--theme-palette-action-selected, rgba(0, 0, 0, 0.08))',
          },
        }}
      >
        {isDarkMode ? (
          <LightModeIcon sx={{ color: 'inherit' }} />
        ) : (
          <DarkModeIcon sx={{ color: 'inherit' }} />
        )}
      </IconButton>
    </Tooltip>
  );
}

export default ThemeToggle;